import { useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { useNavigate, Link } from 'react-router-dom';
import './LoginPage.css';

const LoginPage = () => {
    const { login } = useAuth();
    const navigate = useNavigate();
    const [error, setError] = useState(null);
    const [fields, setFields] = useState({
        email: '',
        password: ''
    });
    const [touched, setTouched] = useState({});

    const validations = {
        email: (v) => {
            if (!v) return 'O e-mail é obrigatório.';
            if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v)) return 'E-mail inválido.';
            return null;
        },
        password: (v) => {
            if (!v) return 'A senha é obrigatória.';
            return null;
        }
    };

    const errors = {
        email: validations.email(fields.email),
        password: validations.password(fields.password)
    };

    const isFormValid = Object.values(errors).every(e => e === null);

    const handleChange = (e) => {
        setFields(prev => ({ ...prev, [e.target.name]: e.target.value }));
    };

    const handleBlur = (e) => {
        setTouched(prev => ({ ...prev, [e.target.name]: true }));
    };

    const handleLogin = async (e) => {
        e.preventDefault();
        setError(null);

        try {
            await login(fields.email, fields.password);
            navigate('/app');
        } catch {
            setError('E-mail ou senha incorretos.');
        }
    };

    return (
        <div className="login-page">
            <div className="login-card">
                <div className="login-logo">
                    <div className="login-logo-icon">NWK</div>
                    <span className="login-logo-text">NewWeekKanban</span>
                </div>

                <h1 className="login-title">Bem-vindo de volta</h1>
                <p className="login-subtitle">Entre na sua conta para continuar</p>

                {error && <div className="login-error">{error}</div>}

                <form className="login-form" onSubmit={handleLogin}>
                    <div className="login-field">
                        <label>E-mail</label>
                        <input
                            name="email"
                            type="email"
                            placeholder="seu@email.com"
                            value={fields.email}
                            onChange={handleChange}
                            onBlur={handleBlur}
                        />
                        {touched.email && errors.email &&
                            <span className="login-field-error">{errors.email}</span>
                        }
                    </div>
                    <div className="login-field">
                        <label>Senha</label>
                        <input
                            name="password"
                            type="password"
                            placeholder="••••••••"
                            value={fields.password}
                            onChange={handleChange}
                            onBlur={handleBlur}
                        />
                        {touched.password && errors.password &&
                            <span className="login-field-error">{errors.password}</span>
                        }
                    </div>
                    <button
                        type="submit"
                        className="login-btn"
                        disabled={!isFormValid}
                    >
                        Entrar
                    </button>
                </form>

                <div className="login-footer">
                    Não tem uma conta? <Link to="/register">Criar conta</Link>
                </div>
            </div>
        </div>
    );
};

export default LoginPage;